import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import SelectSearch, { fuzzySearch } from 'react-select-search';
import { toast, ToastContainer } from 'react-toastify';
import { getLastRuptures, getrapportSuiviRuptures, rapportSuiviRuptures } from '../../../services/Rapports/RapportsApi';
import RelevePrixMarquuee from './marquee/RelevePrixMarquee';
import TableauSuiviRupture from './TableauSuiviRupture';

export default function SuiviRupture() {
    const history = useHistory();

    const { datedebut, datefin } = useParams('')
    const searchInput = useRef();
    const [date_debut, setdate_debut] = useState(datedebut)
    const [date_fin, setdate_fin] = useState(datefin)
    const [ok, setok] = useState(false)
    const [codePDV, setCodePdv] = useState("");
    const [listepdvs, setlistepdvs] = useState([])
    //Results of serach
    const [liste, setliste] = useState([])
    const [listeGrouped, setlisteGrouped] = useState([])
    const [listemessages, setlistemessages] = useState([])

    //--------- Loader ------------------------
    const [loading, setloading] = useState(true)
    //------------- Traduction ---------------
    const [t, i18n] = useTranslation("global");

    useEffect(()=>{
        
        getLastRuptures().then((result) => {
            if(result?.data?.success === 1){
                setlistemessages(result?.data?.liste)
            }
        }).catch((err) => {
            console.log(err)
        });
    },[])
    const saveData = () => {
        //Search  /Magasins
        //Search sous familles / gammes / famille in intervalle [datedebut , datefin]
        setloading(true)
        if (date_debut !== "" && date_fin !== "" ) {
            if (date_debut <= date_fin) {
                setloading(true)
                history.push({
                    pathname: "/suivi/suiviRupture&datedebut=" + date_debut + "&datefin=" + date_fin
                })
        rapportSuiviRuptures(date_debut, date_fin)
            .then((result) => {
                if (result?.data?.success === 1) {
                    setok(true)
                    setlistepdvs(result?.data?.listePDVS)

                }
            }).catch((err) => {
                console.log(err)
            });}
            else if (date_fin < date_debut) {
                toast(t("messages.dateinf"), { type: "warning", position: "top-right" })
            }
    }}
    // Handle Change Marque
    const handleChangePDV = (...args) => {
        setCodePdv(args[1].value)
    };
    const searchItems = () => {

        setloading(true)
        getrapportSuiviRuptures(date_debut, date_fin, codePDV)
            .then((result) => {
                if (result?.data?.success === 1) {
                    setliste(result?.data?.liste)
                    console.log(result?.data);

                    setlisteGrouped(result?.data?.listeGrouped)
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                setloading(false)
            })
    }
    return (
        <div>
            <div className="page-header">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="#"><i className="fe fe-life-buoy mr-1" /> {t('suivi')} </a></li>
                    <li className="breadcrumb-item active" aria-current="page">{t('Suivi Rupture')}</li>
                </ol>
            </div>
              {/**---------------------- INFORMATIONS (Derniers Relve prix) --------------------------- */}
             <div className="row mb-3">
               <RelevePrixMarquuee t={t} listemessages={listemessages} />
            </div>
            <div className='row'>
                <div className='col-4' />
                <div className='col-4'>
                    <div className='input-group'>
                        <input type="date" className='form-control fs-12' value={date_debut} onChange={(e) => setdate_debut(e.target.value)} />
                        <input type="date" className='form-control fs-12' value={date_fin} onChange={(e) => setdate_fin(e.target.value)} />
                        <button className='btn btn-azure' onClick={() => saveData()}> <i className='ti-search' /></button>

                    </div>
                </div>
                <ToastContainer />
                <div className='col-4' />
                {ok ? <>
                    <div className='col-4' />
                    <div className='col-4 mt-2 text-center'>
                        <div className='input-group text-center '>
                            <label className='mt-3 fs-12'> Points de ventes : </label>
                            <SelectSearch
                                options={listepdvs}
                                search
                                ref={searchInput}
                                onChange={handleChangePDV}
                                filterOptions={fuzzySearch}
                                emptyMessage={() => <div style={{ textAlign: 'center', fontSize: '0.8em' }}>{t('Zoning.Aucunresultat')}</div>}
                                placeholder={t('Choisir un magasin')}
                            />

                            <button className='btn btn-secondary' onClick={() => searchItems()}> <i className='ti-search' /></button>

                        </div>
                    </div>
                    <div className='col-4' />
                </> : null}
            </div>
            <div className='row mt-4'>
                {loading ? <div className='col-12'>
                    <div className="alert bg-purple mb-5 py-4" role="alert">
                        <div className="d-flex">
                            <i className="icon icon-info mr-3 fs-30"></i>
                            <div>
                                <h4 className="alert-heading fs-16 mt-3"> {t("Vous devez sélectionner les champs nécessaires pour visualiser le tableau de suivi des Ruptures")} </h4>
                                <p></p>
                            </div>
                        </div>
                    </div>
                </div> :
                <TableauSuiviRupture liste={liste} listeGrouped={listeGrouped} t={t} />

                }
            </div>
        </div>)
}
